<template>
  <v-container pa-0 fill-height>
    <v-btn
      v-if="supplierId != '' || params"
      text
      small
      @click="onClick"
      :class="{ 'disable-events': source && source.name == 'GTWEB_MP' }"
    >
      <v-icon left small>{{ icon }}</v-icon>

      <v-tooltip bottom v-if="source && source.name != 'GTWEB'">
        <template v-slot:activator="{ on, attrs }">
          <v-icon color="purple" v-bind="attrs" v-on="on" left>
            {{
              `mdi-alpha-${source.name
                .replace("GTWEB_", "")
                .charAt(0)
                .toLowerCase()}-circle-outline`
            }}
          </v-icon>
        </template>
        <span>{{ source.name.replace("GTWEB_", "") }}</span>
      </v-tooltip>
      <v-tooltip bottom v-if="linkParent != ''">
        <template v-slot:activator="{ on, attrs }">
          <v-icon color="light-green" v-bind="attrs" v-on="on" left>
            {{ `mdi-alpha-l-circle-outline` }}
          </v-icon>
        </template>
        <span>Link Parent: {{ linkParent }}</span>
      </v-tooltip>
      <v-tooltip bottom v-if="isHistoricRate">
        <template v-slot:activator="{ on, attrs }">
          <v-icon color="purple" v-bind="attrs" v-on="on" left small>
            mdi-history
          </v-icon>
        </template>
        <span>Historic Rate</span>
      </v-tooltip>
      {{ label }}
    </v-btn>
    <span v-else>
      <v-icon left small>{{ icon }}</v-icon>
      <v-tooltip bottom v-if="linkParent != ''">
        <template v-slot:activator="{ on, attrs }">
          <v-icon color="light-green" v-bind="attrs" v-on="on" left>
            {{ `mdi-alpha-l-circle-outline` }}
          </v-icon>
        </template>
        <span>Link Parent: {{ linkParent }}</span>
      </v-tooltip>
      {{ label }}
    </span>
    <div v-if="debug">
      <pre>linkParent: {{ linkParent }}</pre>
    </div>
  </v-container>
</template>

<script>
export default {
  name: "supplier-label",

  props: {
    value: {
      type: String,
      defaule: () => "Supplier Name",
    },
    supplierType: {
      type: String,
      default: () => "ACCOMMODATION",
    },
    supplierId: {
      type: String,
      default: () => "",
    },
    callback: {
      type: Function,
      default: null,
    },
    source: {
      type: Object,
      default: () => null,
    },
    yearShift: {
      type: Number,
      default: () => 0,
    },
    linkParent: {
      type: String,
      default: () => "",
    },
    newTab: {
      type: Boolean,
      default: () => false,
    },
  },

  data() {
    return {
      debug: false,
      params: null,
    };
  },

  computed: {
    isHistoricRate() {
      return this.yearShift != 0;
    },
    label() {
      return this.params ? this.params.data.supplierName : this.value;
    },
    icon() {
      const map = {
        ACCOMMODATION: "mdi-home",
        ACTIVITY: "mdi-golf",
        TRAVEL: "mdi-airplane",
        TRANSPORT: "mdi-car",
        TRANSFER: "mdi-car",
        OTHER: "mdi-star",
        PACKAGE: "mdi-briefcase",
        TEMPLATE: "mdi-view-list",
        MANDATORY_CHARGES: "mdi-currency-usd",
      };
      const supplierType =
        this.params && this.params.data.serviceType
          ? this.params.data.serviceType
          : this.supplierType;

      return supplierType ? map[supplierType] : "mdi-home";
    },
  },

  methods: {
    onClick() {
      if (this.source && this.source.name == "GTWEB_MP") {
        return;
      }
      if (this.params) {
        this.params.context.componentParent.onShowSupplier(this.params.data)();
      } else if (this.callback) {
        this.callback();
      } else if (this.newTab) {
        window.open(`/supplier/${this.supplierId}/details`, "_blank");
      } else {
        this.$router.push(`/supplier/${this.supplierId}/details`);
      }
    },
  },
};
</script>

<style>
.disable-events {
  pointer-events: none;
}
</style>



// WEBPACK FOOTER //
// src/components/gt/shared/labels/SupplierLabel.vue